import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import Remediation from './views/Remediation.vue'
import Alerts from './views/Alerts.vue'
import Keywords from './views/Keywords.vue'
import Profiles from './views/Profiles.vue'
import Settings from './views/Settings.vue'

import Partners from './views/Partners.vue'
import Partner from './views/Partner.vue'

import Accounts from './views/Accounts.vue'
import Account from './views/Account.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/partners',
      name: 'partners',
      component: Partners
    },
    {
      path: '/partner',
      name: 'partner',
      component: Partner
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: Accounts
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: Profiles
    },
    {
      path: '/keywords',
      name: 'keywords',
      component: Keywords
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: Alerts
    },
    {
      path: '/remediation',
      name: 'remediation',
      component: Remediation
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    }
  ]
})
